/**
 * ScenarioCriticalityBadge — chip that signals how load-bearing a
 * scenario is ("Critical path" / "Important" / "Optional"). Sits next to
 * scenario names in lists and dropdowns; tone follows `criticalityTone`.
 */

import { Chip, type ChipTone } from "@/components/ui/chip";
import { cn } from "@/lib/utils";
import {
  criticalityLabel,
  criticalityTone,
  type TaskCriticality,
} from "./vocabulary";

interface ScenarioCriticalityBadgeProps {
  criticality: TaskCriticality;
  size?: "sm" | "md";
  className?: string;
}

const sizeClasses = {
  sm: undefined,
  md: "h-6 px-2",
} as const;

export function ScenarioCriticalityBadge({
  criticality,
  size = "sm",
  className,
}: ScenarioCriticalityBadgeProps) {
  const tone = criticalityTone(criticality);
  const chipTone: ChipTone =
    tone === "critical" || tone === "important" ? tone : "muted";
  return (
    <Chip tone={chipTone} className={cn(sizeClasses[size], className)}>
      <span className="sr-only">Criticality: </span>
      {criticalityLabel(criticality)}
    </Chip>
  );
}
